export const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'https://firelabs.it/wiml-api').replace(/\/$/, '');
const BASE = `${API_BASE_URL}/api/v1/admin`;
const TOKEN = 'firelabs.token';
export const session = {
  token: () => sessionStorage.getItem(TOKEN),
  save: token => sessionStorage.setItem(TOKEN, token),
  clear: () => { sessionStorage.removeItem(TOKEN); sessionStorage.removeItem('token'); sessionStorage.removeItem('companyId'); },
};
export async function api(path, options = {}) {
  const response = await fetch(BASE + path, {
    ...options,
    headers: { 'Content-Type': 'application/json', ...(session.token() ? { Authorization: `Bearer ${session.token()}` } : {}), ...options.headers },
    body: options.body === undefined ? undefined : JSON.stringify(options.body), cache: 'no-store',
  });
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    if (response.status === 401 && path !== '/auth/login') { session.clear(); window.dispatchEvent(new Event('firelabs-session-expired')); }
    throw new Error(body.message || body.detail || body.reason || (response.status === 403 ? 'Accesso riservato agli amministratori.' : 'Operazione non riuscita. Riprova tra poco.'));
  }
  if (response.status === 204) return null;
  return response.headers.get('content-type')?.includes('text/html') ? response.text() : response.text().then(text => text ? JSON.parse(text) : null);
}
export const appPath = code => `/applications/${encodeURIComponent(code)}`;
export const requestId = () => {
  const bytes = new Uint8Array(16); window.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
  const h = [...bytes].map(n => n.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0,8)}-${h.slice(8,12)}-${h.slice(12,16)}-${h.slice(16,20)}-${h.slice(20)}`;
};
